export default {
  methods: {
    onGoToWallet() {
      this.$router.push({ name: 'wallet' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-combined/footer/footer.js